/**
 * Sanitizes a string for use in a filename: lowercase, spaces to dashes, invalid chars to dash.
 * Returns empty string if the result would be empty.
 */
export const sanitizeForFilename = (name: string): string => {
  const sanitized = name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\-_]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return sanitized;
};

export const computeFileExtension = (
  fileName: string | undefined,
): string | null => {
  if (fileName?.includes('.')) {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    return fileName.split('.').pop().toLowerCase();
  }

  return null;
};

export const getVersionAndTypeBeingDisplayed = (
  fileName: string,
): {
  fileName: string;
  ext: string | undefined;
  version: string | null;
} => {
  const [, rest] = fileName.split('_');
  const ext = fileName.split('.').at(-1);

  if (!rest) {
    return { fileName, ext, version: 'original' };
  }

  const splitRest = rest.split('.');
  const version = splitRest.slice(0, splitRest.length - 1).join('.');

  return { fileName, ext, version };
};

/**
 * Generates a PDF filename with optional name sanitization
 *
 * @param prefix - The prefix for the filename (e.g., "claim-summary", "benefits-summary")
 * @param id - The unique identifier to append
 * @param extension - Optional extension to include (default: "pdf")
 * @param name - Optional name to include (will be sanitized)
 * @returns The generated filename with the specified extension
 */
export const generateFileName = (
  prefix: string,
  id: string,
  extension: string,
  name?: string,
): string => {
  const sanitizedName = name
    ?.replace(/[^a-zA-Z0-9\s-]/g, '')
    .replace(/\s+/g, '-');

  const filename = sanitizedName
    ? `${prefix}-${sanitizedName}-${id}`
    : `${prefix}-${id}`;

  return `${filename}.${extension}`;
};
